<script lang="ts">
  import { comprehensive, hover, identifier, modal, positions } from "./stores";

  let show: boolean;
  $: show = $positions.length == 0 ? false : true;
</script>

<aside class="container" class:show>
  {#if $positions.length > 0}
    <button class="btn btn-light toggle" on:click={() => (show = !show)} type="button">
      {show ? "« Skjul" : "» Vis"}
    </button>
  {/if}
  <div class="header">
    <p>Antall posisjoner funnet: {$positions.length}</p>
    <div class="text-end">
      <button class="btn-link" on:click={() => identifier.set("")} type="button">Vis alle på kartet</button>
    </div>
  </div>
  <ul class="positions">
    {#each $positions as pos}
      <li
        aria-pressed="false"
        class="item link"
        class:active={pos.identifier === $identifier}
        class:hover={pos.identifier === $hover}
        on:blur={() => hover.set("")}
        on:click={() => identifier.set(pos.identifier)}
        on:focus={() => hover.set(pos.identifier)}
        on:mouseout={() => hover.set("")}
        on:mouseover={() => hover.set(pos.identifier)}
        role="button"
      >
        <span class="address-lg">{pos.addressData.address}</span>
        <span class="address-sm">{pos.addressData.zipCode}&nbsp;{pos.addressData.place}</span>
        <span class="address-sm">{pos.addressData.municipality}</span>
        <button class="btn btn-sm" on:click={() => modal.set(pos.identifier)} type="button">Se detaljer</button>
      </li>
    {/each}
    {#if $comprehensive === false}
      <li class="item text-center">
        <button class="btn btn-secondary" on:click={() => comprehensive.set(true)} type="button">Last flere</button>
      </li>
    {/if}
  </ul>
</aside>

<style>
  .container {
    align-items: center;
    background-color: rgba(255, 255, 255, 0.9);
    border-right: solid 1px #222;
    bottom: 0px;
    display: flex;
    flex-direction: column;
    left: -320px;
    position: absolute;
    top: 80px;
    transition: left 250ms;
    width: 320px;
  }
  .container.show {
    left: 0px;
  }
  .toggle {
    left: 328px;
    position: absolute;
    top: 8px;
  }
  .header {
    background-color: #f3f3f3;
    border-bottom: solid 1px #e9e9e9;
    flex-shrink: 1;
    padding: 16px;
    width: 100%;
  }
  .positions {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    list-style-type: none;
    padding: 0;
    overflow-y: scroll;
    width: 100%;
  }
  .positions .item {
    padding: 16px;
  }
  .positions .link {
    background-color: #fff;
    border-bottom: solid 1px #222;
    cursor: default;
  }
  .positions .link:hover,
  .positions .link.hover {
    background-color: #cbd5de;
  }
  .positions .link.active {
    background-color: #0058a3;
    color: #fff;
  }
  .address-lg,
  .address-sm {
    display: block;
  }
  .address-lg {
    font-size: 1.25rem;
  }
</style>
